import { useExaminerDetails } from './useExaminerDetails'

export function useExaminerName() {
  const details = useExaminerDetails()

  return details.context.data?.name ?? ''
}
